import styled from 'styled-components';
import { Typography } from '../typography';
import { Button } from '../button';
import { i18n } from '../../i18n';

export const Card = styled.div`
  background: var(--white);
  border-radius: var(--border-radius-6);
  border: 0.1rem solid var(--gray-50);
  padding: 1.6rem;
  display: grid;
  grid-template-rows: auto 1fr;
  row-gap: 1.2rem;
`;

const Header = styled.div`
  display: grid;
  grid-template-columns: 1fr max-content;
  align-items: center;
  column-gap: 1.2rem;
`;

const ViewAllWrap = styled.div`
  display: grid;
  justify-items: end;
`;

interface CardHeaderProps {
  title: string;
  viewAllLink?: string;
}

export const CardHeader = ({ title, viewAllLink }: CardHeaderProps) => {
  return (
    <Header>
      <Typography
        variant="textS"
        weight="semibold"
        color="--gray-90"
        style={{ margin: 0, textTransform: 'uppercase', letterSpacing: '0.04em' }}
      >
        {title}
      </Typography>
      {viewAllLink && (
        <ViewAllWrap>
          <Button
            to={viewAllLink}
            variant="text"
            data-color="white"
            size="small"
            style={{ padding: 0, minWidth: 'max-content' }}
          >
            {i18n.t('button.viewAll')}
          </Button>
        </ViewAllWrap>
      )}
    </Header>
  );
};
